import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SepidzGridModule } from "projects/sepidz-web-framework-data-grid/src/lib/grid.module";
import { SharedModule } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { EstablishmentTheReserveOfYearsOfServiceFormComponent } from "./establishment-the-reserve-of-years-of-service-form/establishment-the-reserve-of-years-of-service-form.component";
import { MonthlySalaryCalculationInformationComponent } from "./monthly-salary-calculation-information/monthly-salary-calculation-information.component";
import { RewardPaymentEffectWorkFormComponent } from "./reward-payment-effect-work-form/reward-payment-effect-work-form.component";
import { VacationBuyInformationFormComponent } from "./vacation-buy-Information-form/vacation-buy-Information-form.component";

const components = [
  MonthlySalaryCalculationInformationComponent,
  VacationBuyInformationFormComponent,
  RewardPaymentEffectWorkFormComponent,
  EstablishmentTheReserveOfYearsOfServiceFormComponent,
];
@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, FormsModule, SharedModule, SepidzGridModule],
})
export class MonthlySalaryCalculationInformationModule {}
